import { AbstractPropertyType } from "../util/property/AbstractPropertyType";
import PropertyTypeRegistry from "../util/property/PropertyTypeRegistry";

export interface IPropertyTypeArgs {
	name: string;
	label?: string; // string to display in the ui if it should be diffrent form name
	group?: string;
}

export function PropertyType(args?: IPropertyTypeArgs) {
	return <T extends AbstractPropertyType<any, any>>(PropertyType: any) => {

		// create the service
		const impl = new PropertyType(args.name, args.label, args.group);

		// attempt to register the type
		PropertyTypeRegistry.register(impl);

		// return the prorotype unmodified
		return PropertyType;
	};
}



// WEBPACK FOOTER //
// ./src/core/decorators/PropertyType.ts